import { useActivity } from 'modules/core/lib/activities/activity'
import type { ActivityComponent } from 'modules/core/lib/activities/types'

import EditTaskFormModal from 'modules/procurement/components/taskForms/EditTaskFormModal'

interface EditTaskFormData extends Record<string, string> {
  taskFormId: string
  taskFormName: string
  taskFormCategory: string
}

export const EditTaskFormActivity: ActivityComponent<EditTaskFormData> = ({
  taskFormId,
  taskFormName,
  taskFormCategory,
}) => {
  const { open, closeActivity } = useActivity()

  if (!open) return null

  const category: 'basic' | 'provider' = taskFormCategory === 'provider' ? 'provider' : 'basic'

  return (
    <EditTaskFormModal
      taskFormId={taskFormId}
      taskFormName={taskFormName}
      taskFormCategory={category}
      onClose={closeActivity}
    />
  )
}
